import { render, staticRenderFns } from "./CRHeader.vue?vue&type=template&id=3e4d5c38"
import script from "./CRHeader.vue?vue&type=script&lang=js"
export * from "./CRHeader.vue?vue&type=script&lang=js"
import style0 from "./CRHeader.vue?vue&type=style&index=0&id=3e4d5c38&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports